// // src/Components/Visitors/Visitors.jsx
// import React, { useState } from "react";
// import { Card, Nav, Alert } from "react-bootstrap";
// import SecurityGatePanel from "./SecurityGatePanel";
// import ResidentPassGenerator from "./ResidentPassGenerator";
// import QRKioskEntry from "./QRKioskEntry";

// export default function Visitors({
//   community,
//   currentUser,
//   isAdmin,
//   isManager,
//   isResident,
// }) {
//   const [tab, setTab] = useState("security"); // security | resident | kiosk

//   const canSecurity = isAdmin || isManager; // or dedicated security role if you have
//   const canResident = isResident || isAdmin || isManager;

//   return (
//     <Card>
//       <Card.Header>
//         <Nav
//           variant="tabs"
//           activeKey={tab}
//           onSelect={(k) => setTab(k || "security")}
//         >
//           {canSecurity && (
//             <Nav.Item>
//               <Nav.Link eventKey="security">Security Gate</Nav.Link>
//             </Nav.Item>
//           )}
//           {canResident && (
//             <Nav.Item>
//               <Nav.Link eventKey="resident">Resident Pass</Nav.Link>
//             </Nav.Item>
//           )}
//           <Nav.Item>
//             <Nav.Link eventKey="kiosk">Community QR Kiosk</Nav.Link>
//           </Nav.Item>
//         </Nav>
//       </Card.Header>
//       <Card.Body>
//         {!community?.id ? (
//           <Alert variant="warning">Community not loaded.</Alert>
//         ) : tab === "security" && canSecurity ? (
//           <SecurityGatePanel community={community} currentUser={currentUser} />
//         ) : tab === "resident" && canResident ? (
//           <ResidentPassGenerator
//             community={community}
//             currentUser={currentUser}
//           />
//         ) : tab === "kiosk" ? (
//           <QRKioskEntry community={community} />
//         ) : (
//           <Alert variant="warning">You do not have access to this tab.</Alert>
//         )}
//       </Card.Body>
//     </Card>
//   );
// }

import React, { useState } from "react";
import { Card, Nav, Alert } from "react-bootstrap";
import SecurityGatePanel from "./SecurityGatePanel";
import ResidentPassGenerator from "./ResidentPassGenerator";
import KioskDisplay from "./KioskDisplay";

export default function Visitors({
  community,
  currentUser,
  isAdmin,
  isManager,
  isResident,
}) {
  const [tab, setTab] = useState("security"); // security | resident | kiosk

  const canSecurity = isAdmin || isManager; // treat manager/admin as security for now
  const canResident = isResident || isAdmin || isManager;

  return (
    <Card>
      <Card.Header>
        <Nav
          variant="tabs"
          activeKey={tab}
          onSelect={(k) => setTab(k || "security")}
        >
          {canSecurity && (
            <Nav.Item>
              <Nav.Link eventKey="security">Security Gate</Nav.Link>
            </Nav.Item>
          )}
          {canResident && (
            <Nav.Item>
              <Nav.Link eventKey="resident">Resident Pass</Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item>
            <Nav.Link eventKey="kiosk">Community QR</Nav.Link>
          </Nav.Item>
        </Nav>
      </Card.Header>
      <Card.Body>
        {!community?.id ? (
          <Alert variant="warning">Community not loaded.</Alert>
        ) : tab === "security" && canSecurity ? (
          <SecurityGatePanel community={community} currentUser={currentUser} />
        ) : tab === "resident" && canResident ? (
          <ResidentPassGenerator
            community={community}
            currentUser={currentUser}
          />
        ) : tab === "kiosk" ? (
          <KioskDisplay community={community} />
        ) : (
          <Alert variant="warning">You do not have access to this tab.</Alert>
        )}
      </Card.Body>
    </Card>
  );
}
